import { useState } from 'react';
import Spinner from '../Spinner';
import SegmentForm from './SegmentForm';

import { Box } from '@mantine/core';
import { useSelector } from 'react-redux';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

const SegmentDetailsForm = ({ segment, onSave, onDelete, onBack, onDuplicate, disabledScopes = [] }) => {
  const fetch = useFetch();

  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { domain } = useSelector((state) => state.domain);

  const update = (segment) => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/segments/${segment.id}`, {
      method: 'PUT',
      body: JSON.stringify(segment),
    })
      .then(onSave)
      .catch(setUserError);
  };

  const del = (cb) => {
    return fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/segments/${segment.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        onDelete();
      })
      .catch(setLoadError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!segment) {
    return <Spinner />;
  }

  return (
    <>
      <SegmentForm
        segment={segment}
        saveSegment={(segment) => update(segment)}
        deleteSegment={onDelete ? (cb) => del(cb) : undefined}
        onBack={onBack}
        onDuplicate={onDuplicate}
        disabledScopes={disabledScopes}
      />
      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default SegmentDetailsForm;
